module.exports = __webpack_public_path__ + "static/logo_partner-c1f9e346b1ac09e493d728f28dc5ff54.png";